import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { favoriteListsApi as n } from "@maat/api-main";
import { useIsAuthenticated as r } from "@maat/store-auth";
//#region src/favoriteLists/useFavoriteListsFeedQuery.ts
var i = (i = 5) => {
	let a = r();
	return t({
		queryKey: e.feed(),
		fetchPage: (e) => n.getFeed({
			page: e,
			pageSize: i
		}),
		enabled: a,
		key: "lists"
	});
};
//#endregion
export { i as useFavoriteListsFeedQuery };
